// config.ts
export const API_URL = 'https://vectorapi.pythonanywhere.com';
